import { Theme } from "@mui/material/styles";

import makeStyles from "@mui/styles/makeStyles";
import createStyles from "@mui/styles/createStyles";

type styleConfigParam = {
    colors: string[];
    shadow: string;
};

const useStyles = (styleConfig: styleConfigParam) => {
    const linearGradient = `linear-gradient(90deg, ${styleConfig.colors[1]} 0.51%, ${styleConfig.colors[0]} 38.53%, ${styleConfig.colors[1]} 100.51%)`;
    const styles = makeStyles((theme: Theme) =>
        createStyles({
            accordionRoot: {
                marginBottom: theme.spacing(1),
                borderRadius: "8px",
                "& .MuiAccordionSummary-content.Mui-expanded": {
                    margin: "12px 0",
                },
            },
            accordionExpanded: {
                margin: "8px 0 !important",
            },
            summaryRoot: {
                borderRadius: "8px",
                position: "relative",
                backgroundImage: linearGradient,
            },
            summaryExpanded: {
                background: linearGradient,
                border: "none",
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
            },
            summaryContent: {
                display: "grid",
                gridTemplateColumns: "45% 10% 45%",
                alignItems: "center",
            },
            detailsRoot: {
                backgroundImage: linearGradient,
                paddingTop: 0,
                borderBottomLeftRadius: "8px",
                borderBottomRightRadius: "8px",
            },
            listRoot: {
                width: "100%",
                padding: "0 20px",
                marginBottom: "0 !important",
            },
            listItemRoot: {
                padding: 0,
                display: "grid",
                gridTemplateColumns: "50% 50%",
                color: theme.palette.common.white,
                fontSize: "16px",
            },
            lhsLabel: {
                textAlign: "left",
            },
            rhsLabel: {
                textAlign: "right",
            },
            listItemTextPrimary: {
                color: theme.palette.common.white,
                fontSize: "16px",
            },
            arrow: {
                fontSize: "24px",
                "&:hover": {
                    color: "white !important",
                },
            },
            accordionIconWrapper: {
                background: theme.palette.neutrals.dark,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 36,
                height: 36,
                borderRadius: "50px",
                mixBlendMode: "soft-light",
            },
        })
    );

    return styles();
};

export default useStyles;
